import { useMutation, useQueryClient } from 'react-query';
import { AxiosResponse } from 'axios';

// configs
import { API } from 'configs/api';
// keys
import { reactionsQueryKeys } from './reactionsQueryKeys';
// utils
import { getShortUrlFromUrl } from 'utils/url';

const deleteReactionCommentsMutation = async ({
  id,
  data,
}: {
  id: number | string;
  data: { visitorCode: string };
}) => {
  const shortUrl = getShortUrlFromUrl();
  if (!shortUrl) {
    throw new Error('Invalid url');
  }

  const response: AxiosResponse = await API.delete(
    `/playback/${shortUrl}/reactions/${id}`,
    {
      data,
    }
  );

  return response.data;
};

export const useDeleteReactionCommentsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse, Error, any>(
    deleteReactionCommentsMutation,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(reactionsQueryKeys.all());
      },
    }
  );
};
